export default __webpack_public_path__ + "static/media/1266x120_Escoffier_ESource Platform Ads_Banner_1.c10fe796.jpg";